<div class="tw-gap-3"
  [class.tw-flex]="type() === QuizOptionListLayout.Stack"
  [class.tw-flex-col]="type() === QuizOptionListLayout.Stack"
  [class.tw-grid]="type() === QuizOptionListLayout.Grid"
  [class.tw-grid-cols-2]="type() === QuizOptionListLayout.Grid">
  @for (option of options(); track $index) {
    <div role="button" tabindex="0"
      class="tw-w-full tw-min-h-14 tw-flex tw-items-center tw-justify-start tw-gap-2 tw-px-3 tw-py-1 tw-rounded-lg tw-border tw-border-solid tw-text-left tw-whitespace-normal tw-cursor-pointer"
      [class.tw-col-span-2]="isFullWidthItem($index)"
      [class.tw-bg-teal-100]="isSelected($index)"
      [class.tw-border-teal-600]="isSelected($index)"
      [class.tw-bg-gray-75]="!isSelected($index)"
      [class.tw-border-gray-200]="!isSelected($index)"
      [attr.aria-disabled]="disabled()"
      [attr.aria-pressed]="isSelected($index)"
      (click)="onOptionClick($index)"
      (keydown.enter)="onOptionKeydown($index, $event)"
      (keydown.space)="onOptionKeydown($index, $event)">
      <span class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-shrink-0">
        @if (isSelected($index)) {
          <span class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-teal-600 tw-flex tw-items-center tw-justify-center">
            <em class="cs-icon-tick tw-text-200 tw-text-white"></em>
          </span>
        } @else {
          <span class="tw-w-6 tw-h-6 tw-rounded-full tw-border-2"
            [class.tw-border-gray-400]="!isMuted($index)"
            [class.tw-border-gray-200]="isMuted($index)"></span>
        }
      </span>
      <span class="tw-font-lexend tw-text-300"
        [class.tw-text-black]="!isMuted($index)"
        [class.tw-text-gray-400]="isMuted($index)">{{ optionLabel(option) }}</span>
    </div>
  }
</div>
